export enum DiscountType {
  Value  = 1,
  Percentage = 2 
}